import script from "./RowActionDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./RowActionDropdown.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__